var scope_0 = require('/var/www/html/blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7f76d23c93e37694485da54b8011f854.js').default;
var scope_1 = require('/var/www/html/blog/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/abc8b2245d68bf2364bb8cf920ffe3cd.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    